module.exports = __webpack_public_path__ + "seller/img/mr.720483ea.jpg";